import React, { Suspense } from 'react';

// import TopBar from 'components/organisms/TopBar';
// import SideBar from 'components/organisms/SideBar';

// import { useMedia } from 'utils/media';

const App = ({ children }) => {
	// const media = useMedia();

	return (
		<Suspense fallback={<div>Loading...</div>}>
			{/* <TopBar /> */}
			<div className="wrapper">{children}</div>
		</Suspense>
	);
};

export default App;
